import Login from "./views/auth/Login";
import LoginPage from "./views/newAuth/Login";
import SendOtp from "./views/newAuth/SendOtp";
import ProvideOtp from "./views/newAuth/ProvideOtp";
import DashboardPage from "./views/dashboard/Dashboard"
import Dashboard from "./views/Dashboard";
import InventoryView from "./views/InventoryView";
import Users from "./views/Users";
import Settings from "./views/Settings";
import PurchaserView from "./views/PurchaserView";
import CategoryView from "./views/CategoryView";
import BrandView from "./views/BrandView";
import CardTypeView from "./views/CardTypeView";
import SupplierView from "./views/SupplierView";
import PurchaseOrderView from "./views/PurchaseOrderView";
import ThresholdInventory from "./views/ThresholdInventory";
import Start from "views/trade-in/Start";
import TradeInLogin from "./views/trade-in/Login";
import PurchaserIndex from "./views/purchaser/PurchaserIndex";
import PurchaserProfile from "./views/purchaser/PurchaserProfile";
import PurchaserLogin from "./views/purchaser/PurchaserLogin";
import PurchaserPurchaseOrderView from "./views/purchaser/PurchaserPurchaseOrderView";
import PurchaserInvoice from "./views/purchaser/PurchaserInvoice";
import PurchaserUsers from "./views/purchaser/PurchaserUsers";
import BrandDashboard from "./views/BrandDashboard";
import SupplierDashboard from "./views/SupplierDashboard";
import PurchaserContacts from "./views/purchaser/PurchaserContacts";
import ForgotPassword from "./views/newAuth/ForgotPassword";
import ChangePassword from "./views/newAuth/ChangePassword";
// import PurchaserAPIKeys from "./views/purchaser/PurchaserAPIKeys";
// import NotificationPage from "views/purchaser/NotificationPage";
import Keys from "./views/dashboard/Keys";
import Notifications from "./views/dashboard/Notifications";
import Orders from "./views/dashboard/Orders";
import Profile from "./views/dashboard/Profile";
import Setting from './views/Setting/Setting'
import PurchaserQRLogin from "views/purchaser/PurchaserQRLogin";
import AdminQRLogin from "components/Core/AdminQRLogin";


const routes = [
	{ path: "/dashboard", name: "Dashboard", icon: "fas fa-info-circle", component: Dashboard, layout: "/admin", noShow: true, allowedRoles: [] },
	{ path: "/brands/dashboard/:id", name: "Brand Dashboard", icon: "fas fa-info-circle", component: BrandDashboard, layout: "/admin", noShow: true, allowedRoles: [] },
	{ path: "/supply/dashboard/:id", name: "Supplier Dashboard", icon: "fas fa-info-circle", component: SupplierDashboard, layout: "/admin", noShow: true, allowedRoles: [] },
	{
		path: "/users", name: "Users", icon: "fas fa-users", component: Users, layout: "/admin", noShow: false,
		allowedRoles: [
			"SYSTEM_MANAGER",
			"INTERNAL_MANAGER",
			"INTERNAL",
			"PRODUCT_MANAGER",
			"SUPPLIER_MANAGER",
			"CUSTOMER_SERVICE",
			"COMMERCIAL_MANAGER",
			"ACCOUNTANT_MANAGER"
		]
	},
	{
		path: "/categories", name: "Categories", icon: "fas fa-folder-open", component: CategoryView, layout: "/admin",
		allowedRoles: [
			"SYSTEM_MANAGER",
			"INTERNAL_MANAGER",
			"INTERNAL",
			"PRODUCT_MANAGER",
			"SUPPLIER_MANAGER",
			"CUSTOMER_SERVICE",
			"COMMERCIAL_MANAGER",
			"ACCOUNTANT_MANAGER"
		]
	},
	{
		path: "/brands", name: "Brands", icon: "far fa-copyright", component: BrandView, layout: "/admin",
		allowedRoles: [
			"SYSTEM_MANAGER",
			"INTERNAL_MANAGER",
			"INTERNAL",
			"PRODUCT_MANAGER",
			"SUPPLIER_MANAGER",
			"CUSTOMER_SERVICE",
			"COMMERCIAL_MANAGER",
			"ACCOUNTANT_MANAGER"
		]
	},
	{
		path: "/cardtypes", name: "Gift Card Types", icon: "fas fa-gift", component: CardTypeView, layout: "/admin", noShow: false,
		allowedRoles: [
			"SYSTEM_MANAGER",
			"INTERNAL_MANAGER",
			"INTERNAL",
			"PRODUCT_MANAGER",
			"SUPPLIER_MANAGER",
			"CUSTOMER_SERVICE",
			"COMMERCIAL_MANAGER",
			"ACCOUNTANT_MANAGER"
		]
	},
	{
		path: "/inventory/purchaseorders", name: "Purchase orders", icon: "fas fa-shopping-cart", component: PurchaseOrderView, layout: "/admin", noShow: true,
		allowedRoles: [
			"SYSTEM_MANAGER",
			"INTERNAL_MANAGER",
			"INTERNAL",
			"PRODUCT_MANAGER",
			"SUPPLIER_MANAGER",
			"CUSTOMER_SERVICE",
			"COMMERCIAL_MANAGER",
			"ACCOUNTANT_MANAGER"
		]
	},
	{path: "/inventory/threshold", name :"Threshold Inventory", icon:"fas fa-shopping-cart", component: ThresholdInventory, layout:"/admin",noShow: true, allowedRoles: []},
	{
		path: "/supply", name: "Suppliers", icon: "fas fa-parachute-box", component: SupplierView, layout: "/admin", noShow: false,
		allowedRoles: [
			"SYSTEM_MANAGER",
			"INTERNAL_MANAGER",
			"INTERNAL",
			"PRODUCT_MANAGER",
			"SUPPLIER_MANAGER",
			"CUSTOMER_SERVICE",
			"COMMERCIAL_MANAGER",
			"ACCOUNTANT_MANAGER"
		]
	},
	{
		path: "/purchasers", name: "Purchasers", icon: "fas fa-handshake", component: PurchaserView, layout: "/admin", noShow: false,
		allowedRoles: [
			"SYSTEM_MANAGER",
			"INTERNAL_MANAGER",
			"INTERNAL",
			"PRODUCT_MANAGER",
			"SUPPLIER_MANAGER",
			"CUSTOMER_SERVICE",
			"COMMERCIAL_MANAGER",
			"ACCOUNTANT_MANAGER"
		]
	},
	{
		path: "/inventory", name: "Inventory", icon: "fas fa-boxes", component: InventoryView, layout: "/admin", noShow: false,
		allowedRoles: [
			"SYSTEM_MANAGER",
			"INTERNAL_MANAGER",
			"INTERNAL",
			"PRODUCT_MANAGER",
			"COMMERCIAL_MANAGER",
			"CUSTOMER_SERVICE",
			"SUPPLIER_MANAGER",
			"ACCOUNTANT_MANAGER"
		]
	},

	{ path: "/platform-setup", name: "Settings", icon: "fas fa-wrench", component: Settings, layout: "/admin", noShow: true, allowedRoles: [] },

	{ path: "/login", name: "Login", icon: "", component: Login, layout: "/auth", noShow: true, allowedRoles: [] },
	{ path: "/send-otp", name: "SendOtp", icon: "", component: SendOtp, layout: "/auth", noShow: true, allowedRoles: [] },
	{ path: "/verify-otp", name: "ProvideOtp", icon: "", component: ProvideOtp, layout: "/auth", noShow: true, allowedRoles: [] },
	{ path: "/admin-qr", name: "Admin QR", icon: "fas fa-info-circle", component: AdminQRLogin, layout: "/auth", noShow: true, allowedRoles: [] },

	{ path: "/forgot-password/:code", name: "Forgot Password", icon: "", component: Login, layout: "/auth", noShow: true, allowedRoles: [] },

	{ path: "/start", name: "Trade-in", icon: "", component: Start, layout: "/trade-in", noShow: true, allowedRoles: [] },
	{ path: "/login", name: "Trade-in", icon: "", component: TradeInLogin, layout: "/trade-in", noShow: true, allowedRoles: [] },
   
	// { path: "/dashboard", name: "Dashboard", icon: "fas fa-info-circle text-primary", component: PurchaserIndex, layout: "/purchaser", noShow: false, allowedRoles: [] },
	{ path: "/dashboard", name: "Dashboard", icon: "fas fa-th-large text-primary", component: DashboardPage, layout: "/purchaser", noShow: false, allowedRoles: [] },
	// { path: "/profile", name: "Profile", icon: "ni ni-single-02 text-primary", component: PurchaserProfile, layout: "/purchaser", noShow: false, allowedRoles: [] },
	{ path: "/profile", name: "Profile", icon: "far fa-user-circle text-primary", component: Profile, layout: "/purchaser", noShow: false, allowedRoles: [] },
	// { path: "/purchaseorders", name: "Purchase Orders", icon: "fas fa-cash-register text-primary", component: PurchaserPurchaseOrderView, layout: "/purchaser", noShow: false, allowedRoles: [] },
	{ path: "/purchaseorders", name: "Orders", icon: "fas fa-box-open text-primary", component: Orders, layout: "/purchaser", noShow: false, allowedRoles: [] },
	// { path: "/order-summary", name: "Summary", icon: "fas fa-circle text-primary", component: OrderSummary, layout: "/purchaser", noShow: false, allowedRoles: [] },
	{ path: "/invoice", name: "Invoice", icon: "fas fa-file-invoice text-primary", component: PurchaserInvoice, layout: "/purchaser", noShow: false, allowedRoles: [] },
	{ path: "/contacts", name: "Contacts List", icon: "far fa-id-badge text-primary", component: PurchaserContacts, layout: "/purchaser", noShow: false, allowedRoles: [] },
	// { path: "/users", name: "Users", icon: "fas fa-users text-primary", component: PurchaserUsers, layout: "/purchaser", noShow: false, allowedRoles: [] },
	// { path: "/notification", name: "Notification", icon: "fas fa-key text-primary", component: NotificationPage, layout: "/purchaser", noShow: false, allowedRoles: [] },
	{ path: "/notification", name: "Notification", icon: "fas fa-bell text-primary", component: Notifications, layout: "/purchaser", noShow: false, allowedRoles: [] },

	// { path: "/keys", name: "API keys", icon: "fas fa-key text-primary", component: PurchaserAPIKeys, layout: "/purchaser", noShow: false, allowedRoles: [] },
	{ path: "/keys", name: "API keys", icon: "fas fa-key text-primary", component: Keys, layout: "/purchaser", noShow: false, allowedRoles: [] },


	// { path: "/login", name: "Login", icon: "fas fa-circle text-primary", component: PurchaserLogin, layout: "/purchaser-auth", noShow: true, allowedRoles: [] },
	{ path: "/login", name: "Login", icon: "fas fa-circle text-primary", component: LoginPage, layout: "/purchaser-auth", noShow: true, allowedRoles: [] },
	// { path: "/forgot-password/:code", name: "Forgot Password", icon: "", component: PurchaserLogin, layout: "/purchaser-auth", noShow: true, allowedRoles: [] },
	{ path: "/forgot-password", name: "Forgot Password", icon: "", component: ForgotPassword, layout: "/purchaser-auth", noShow: true, allowedRoles: [] },
	{ path: "/change-password", name: "Forgot Password", icon: "", component: ChangePassword, layout: "/purchaser-auth", noShow: true, allowedRoles: [] },
	{ path: "/send-otp", name: "SendOtp", icon: "", component: SendOtp, layout: "/purchaser-auth", noShow: true, allowedRoles: [] },
	{ path: "/purchaser-qr-login", name: "Purchaser QR", icon: "", component: PurchaserQRLogin, layout: "/purchaser-auth", noShow: true, allowedRoles: [] },
	{ path: "/verify-otp", name: "ProvideOtp", icon: "", component: ProvideOtp, layout: "/purchaser-auth", noShow: true, allowedRoles: [] },
	{
		path: "/settings", name: "Settings", icon: "fa fa-cog", component: Setting, layout: "/admin", noShow: false,
		allowedRoles: [
			"SYSTEM_MANAGER",
			"INTERNAL_MANAGER",
			"INTERNAL",
			"PRODUCT_MANAGER",
			"COMMERCIAL_MANAGER",
			"CUSTOMER_SERVICE",
			"SUPPLIER_MANAGER",
			"ACCOUNTANT_MANAGER"
		]
	},

];
export default routes;
